import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_BOOTSTRAP_PROVIDERS } from './app/app.providers';
import { register } from 'swiper/element/bundle';

register();


declare function logMessage(message: string): void;

logMessage('Bootstrapping der App wird gestartet');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), APP_BOOTSTRAP_PROVIDERS],
})
  .then(() => logMessage('Bootstrapping erfolgreich!'))
  .catch(err => console.error(err));
